<template>
  <div class="footer">
    <div class="inner">
      <div class="grid">
        <div class="col">
          <img alt="SPJ Marketing Doncaster" class="logo" src="../assets/spj.jpg" />
        </div>
        <div class="col">
          <div class="col-heading">Company</div>
          <ul v-if="main_pages">
            <li :key="menu_page.ItemID" v-for="menu_page in main_pages">
              <page-link :to="menu_page.url || '/'">{{ menu_page.name }}</page-link>
            </li>
          </ul>
        </div>
        <div class="col">
          <div class="col-heading">Services</div>
          <ul>
            <li :key="service.ItemID" :to="service.url" v-for="service in services">
              <page-link>{{ service.name }}</page-link>
            </li>
          </ul>
        </div>
        <div class="col">
          <div class="col-heading">Get in touch</div>
          <div class="contact" v-if="settings && settings.telephone">
            <font-awesome-icon icon="phone" />

            <a :href="'tel:' + settings.telephone.replace(/ /g, '')">{{ settings.telephone }}</a>
          </div>
          <div class="contact" v-if="settings && settings.email">
            <font-awesome-icon icon="envelope" />

            <a :href="'mailto:' + settings.email">{{ settings.email }}</a>
          </div>
          <div class="contact" v-if="settings && settings.instagram">
            <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" />
            <a :href="settings.email" aria-label="Instagram" rel="noreferrer" target="_blank">@large_format_print_uk</a>
          </div>

          <div class="contact" v-if="settings && settings.address">
            <font-awesome-icon icon="map-pin" />
            <a href="https://goo.gl/maps/pW1CUNBterbDGNir5" v-html="settings.address.replace(/[\n\r]/g, '<br>')"></a>
          </div>
        </div>
      </div>
      <div class="legal">
        <a href="/privacy-policy">Privacy Policy</a>&nbsp;&copy; SPJ Marketing
        <template v-if="settings && settings.vat_reg"
          >| VAT Registration: {{ settings.vat_reg }}</template
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["servicesPage", "settings", "main_pages"]),
    services() {
      if (!this.servicesPage) return []
      return this.servicesPage.subs
    }
  }
}
</script>

<style scoped>
.footer {
  padding: 5rem 0;
  font-size: 2rem;
  padding-bottom: 3rem;
  color: white;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.logo {
  width: 15rem;
}
.col-heading {
  color: #c1d62f;
  padding-bottom: 2rem;
}
.col ul,
.col ul li {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.col a {
  transition: all 0.3s;
}
.footer a:hover {
  color: #c1d62f;
}

.contact,
.col ul li {
  padding-bottom: 1rem;
  display: block;
  display: table;
  width: 100%;
}

.contact svg {
  width: 3rem;
  margin-right: 1rem;
  float: left;
}

.contact a {
  float: left;
}
.legal {
  padding-top: 5rem;
  font-size: 1.2rem;
  opacity: 0.6;
}

@media screen and (max-width: 800px) {
  .grid {
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 5rem;
  }
}
@media screen and (max-width: 500px) {
  .grid {
    grid-template-columns: 1fr 2fr;
  }
  .col:nth-child(2),
  .col:nth-child(3) {
    display: none;
  }
  .logo {
    width: 7rem;
  }
}
</style>
